import React from 'react';
import {isOrgUnitAccessPopupShown as setIsOrgUnitAccessPopupShown} from '../../../../../actions/popupActions';
import Popup from '../../index';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';

function OrgUnitAccessPopup () {

	const { t } = useTranslation();
	const dispatch = useDispatch();

	const close = () => {
		dispatch(setIsOrgUnitAccessPopupShown(false))
	};

	return (
		<Popup className="upgrade-to-business-popup" onClose={close}>
			<button className="close" onClick={close}>
				<svg width="34" height="34" viewBox="0 0 34 34" fill="none"
				     xmlns="http://www.w3.org/2000/svg">
					<path fillRule="evenodd" clipRule="evenodd"
					      d="M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM8.38383 25.6162C7.79804 25.0304 7.79804 24.0807 8.38383 23.4949L14.8787 17L8.38374 10.5051C7.79795 9.91932 7.79795 8.96957 8.38374 8.38378C8.96952 7.798 9.91927 7.798 10.5051 8.38378L17 14.8787L23.4949 8.38378C24.0807 7.798 25.0305 7.798 25.6163 8.38378C26.202 8.96957 26.202 9.91932 25.6163 10.5051L19.1213 17L25.6162 23.4949C26.202 24.0807 26.202 25.0304 25.6162 25.6162C25.0304 26.202 24.0806 26.202 23.4949 25.6162L17 19.1214L10.5052 25.6162C9.91936 26.202 8.96962 26.202 8.38383 25.6162Z"
					      fill="#FF1938"/>
				</svg>
			</button>
			<h2>{t('orgUnitAccessPopupTitle')}</h2>
			<p className="pb-3">{t('orgUnitAccessPopupMessage')}</p>
			<div>
				<a className="btn btn-primary" href="/account/access-organizationalUnit">{t('btnGiveAccess')}</a>
			</div>
		</Popup>
	)
}

export default OrgUnitAccessPopup;
